"use strict";
/// <reference path="irep.js"/>

IREP.profile = (function () {
    var options;

    var init = function (profileOptions) {
        options = profileOptions;

       // $("#ddlCountry").select2({ width: 265 });
       // $("#ddlProvince").select2({ width: 265 });
       // $("#ddlShirtSize").select2({ width: 265 });
       // $("#ddlPosition").select2({ width: (IREP.options.user.geoCode === "ASMO" ? 665 : 565) });

        $("#ddlCompany").select2({
            placeholder: options.storeName,
            minimumInputLength: (IREP.options.user.geoCode === "ASMO" ? 1 : 2),
            quietMillis: 300,
            width: (IREP.options.user.geoCode === "ASMO" ? 665 : 375),
            allowClear: true,
            formatResult: function (item, can, q) { return item.text },
            formatSelection: function (item, can, q) {
                return item.text.replace(/<br \/>/g, " ");
            },
            ajax: {
                type: "POST",
                url: "../ws/registration.asmx/GetIntegratedStoreListSixParams",
                params: {
                    contentType: "application/json; charset=utf-8"
                },
                dataType: "json",
                data: function (term, page) {
                    var g = IREP.options.user.geoCode;
                    var c = $("#ddlCountry").val();
                    var r = (IREP.options.user.geoCode === "ASMO" ? $("#ddlProvince").val() || "" : "");
                    var u = (IREP.options.user.geoCode === "ASMO" ? $("#ddlUserType").val() || "" : "");
                    var z = ($("#txtPostal") ? $("#txtPostal").val() || '' : '');
                    var s = term;
                    var p = page;
                    return JSON.stringify({
                        geo: g,
                        country: c,
                        search: s,
                        province: r,
                        postal: z,
                        usertype: u,
                        page: p
                    });
                },
                results: function (data, page) {
                    data = JSON.parse(data.d);
                    data = jQuery.map(
                        data,
                        function (x) {
                            return { id: x.Id, text: x.Name };
                        }
                    );
                    return { results: data, more: false };
                }
            }
        }).change(function (e) { });

        // start with terms hidden
        $("#Terms").hide();

        // hide the terms button for non-ASMO
        $("#btnTerms").hide();
        $("#btnNoAccept").hide();

        //determine required fields by geo
        if (IREP.options.user.geoCode == "ASMO") {
            $("#txtCellPhone").removeAttr("required");
            $("#btnSubmit").text("Accept");
            $("#btnSubmit").hide();
            $("#btnNoAccept").hide();
            $("#btnTerms").show();
        } else {
            if (IREP.options.user.geoCode == "EMEA")
            {
                $("#txtCellPhone").removeAttr("required");
            }
            $(".ASMO").hide();
            $("#txtAddress1").removeAttr("required");
            $("#txtCity").removeAttr("required");
            $("#txtPostal").removeAttr("required");
            $("#txtPhone").removeAttr("required");
        };

        //add border for PRC to txtCellPhone
        if (IREP.options.user.geoCode == "PRC") {
            $("#txtCellPhone").css("border", "3px solid #fdc689");
        }

        $("#txtFirstName").change(function () { checkFormData(); });
        $("#txtLastName").change(function () { checkFormData(); });
        $("#txtEmail").change(function () { checkFormData(); });
        $("#txtPhone").change(function () { checkFormData(); });
        $("#txtCellPhone").change(function () { checkFormData(); });
        $("#txtAddress1").change(function () { checkFormData(); });
        $("#txtCity").change(function () { checkFormData(); });
        $("#txtPostal").change(function () { checkFormData(); });

        $("#btnTerms").click(function () { showTerms(); });
        $("#btnSubmit").click(function () { checkFormData(true); });

        $("#profileContainer").show();
    };

    var showTerms = function () {
        var b = checkRequired();
        if (b) {
            $("#formFields").hide();
            $("#Terms").show();
            $("#btnSubmit").show();
            $("#btnNoAccept").show();
            $("#btnTerms").hide();
        };
    };

    var checkRequired = function () {
        var b = true;
        var regexEmail = /\w+([-+.'\w]+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/gi;
        var regexPhone = (function () {
            switch (IREP.options.user.geoCode) {
                case "ASMO":
                    return {
                        msg: "* (###) ###-####",
                        reg: /^\(?\d\d\d\)?(\s+|-)?\(?\d\d\d?\)?(\s+|-)?\(?\d\d\d\d\)?$/
                    };
                    break;
                case "LAR":
                    switch (IREP.options.user.countryCode) {
                        case "BR":
                            return {
                                msg: "* ## ########",
                                reg: /^\+?\(?\d\d\)?(\s+|-)?\(?\d\d\d\d\d?\)?(\s+|-)?\(?\d\d\d\d\)?$/
                            };
                            break;
                        default:
                            return {
                                msg: "* El formato del teléfono no es válido.",
                                reg: /^\+?\(?\d{1,3}\)?(\s|-)?\d{1,5}(\s|-)?\d{4,9}$/
                            };
                            break;
                    };
                    break;
                case "PRC":
                    return {
                        msg: "11位手机号码",
                        reg: /^\d{11}?$/
                    };
                    break;
                default:
                    return {
                        msg: "",
                        reg: ""
                    };
                    break;
            };
            return {
                msg: msg,
                reg: reg
            };
        })();
        var email = $("#txtEmail").val();
        var phone = $("#txtPhone").val();
        var mobile = $("#txtCellPhone").val();

        // check required fields
        $(".error").remove();
        $('input[required="required"]').each(function (i, v) {
            if ((this.getAttribute("data-message") != null) && ((this.getAttribute("disabled") != "disabled") && (this.getAttribute("disabled") != true))) {
                var msg = "<div id='error" + i + "' class='error'>" + this.getAttribute("data-message") + "</div>";
                if (this.id == "chkOldEnough") {
                    if (!this.checked) {
                        $(this).after(msg);
                        b = false;
                    } else {
                        $("#error" + i).remove();
                    };
                } else if ((this.name == "radDisplayName") || (this.name == "radShareInfo") || (this.name == "radReceiveEmail") || (this.name == "radReceiveText") || (this.name == "radSurveys") || (this.name == "radFocus") || (this.name == "radMemberDir")) {
                    var check = false;
                    var names = document.getElementsByName(this.name);
                    for (i = 0; i < names.length; i++) {
                        if (names[i].checked) {
                            check = true;
                        };
                    };
                    if (check == false) {
                        $(this).after(msg);
                        b = false;
                    };
                } else if (v.value == "") {
                    $(this).after(msg);
                    b = false;
                } else {
                    $("#error" + i).remove();
                };
            };
        });

        //shirt size check
        if (IREP.options.user.geoCode === "ASMO") {
            if ($("#ddlShirtSize").val() == "") {
                $("#ddlShirtSize").after("<div id='shirtError' class='error'>&nbsp;* Shirt size is missing.</div>");
                b = false;
            } else {
                $("#shirtError").remove();
            };
        };

        //email regex check
        if (email.match(regexEmail) == null) {
            $("#txtEmail").after("<div id='emError' class='error'>&nbsp;* " + options.errorMsgEmail + "</div>");
            b = false;
        } else {
            $("#emError").remove();
        };

        //phone regex check
        if ((phone.match(regexPhone.reg) == null) && (phone.length > 0)) {
            $("#txtPhone").after("<div id='phError' class='error'>&nbsp;" + regexPhone.msg + "</div>");
            b = false;
        } else {
            $("#phError").remove();
        };

        //mobile regex check
        if ((mobile.match(regexPhone.reg) == null) && (mobile.length > 0)) {
            $("#txtCellPhone").after("<div id='phmError' class='error'>&nbsp;" + regexPhone.msg + "</div>");
            b = false;
        } else {
            $("#phmError").remove();
        };

        return b;
    };

    var checkFormData = function (save) {
        var b = checkRequired();
        $.ajax({
            type: "POST",
            url: options.apiPath + "participant/username/exists",
            contentType: "application/json; charset=utf-8",
            headers: { "PaxUID": IREP.options.user.currentUID },
            data: JSON.stringify({
                username: ($("#txtEmail") ? $("#txtEmail").val() || IREP.options.user.email : IREP.options.user.email),
                paxuid: IREP.options.user.currentUID
            }),
            dataType: "json",
            success: function (msg) {
                if (msg.exists) {
                    $("#txtEmail").after("<div id='emuError' class='error'>&nbsp;* " + options.errorMsgEmailExists + "</div>");
                    return false;
                } else {
                    if ((b) && (save)) {
                        updateProfile();
                    } else {
                        return false;
                    };
                }
            },
            error: function (msg) { }
        });
    };

    var updateProfile = function () {
        var myData = JSON.stringify({
            participantInfo: {
                CountryCode: ($("#ddlCountry") ? $("#ddlCountry").val() || IREP.options.user.countryCode : IREP.options.user.countryCode),
                FirstName: ($("#txtFirstName") ? $("#txtFirstName").val() || IREP.options.user.firstName : IREP.options.user.firstName),
                LastName: ($("#txtLastName") ? $("#txtLastName").val() || IREP.options.user.lastName : IREP.options.user.lastName),
                UserName: ($("#txtEmail") ? $("#txtEmail").val() || IREP.options.user.email : IREP.options.user.email),
                Street: ($("#txtAddress1") ? $("#txtAddress1").val() || '' : ''),
                Street2: ($("#txtAddress2") ? $("#txtAddress2").val() || '' : ''),
                City: ($("#txtCity") ? $("#txtCity").val() || '' : ''),
                ProvinceId: ($("#ddlProvince") ? $("#ddlProvince").val() || '0' : '0'),
                Postal: ($("#txtPostal") ? $("#txtPostal").val() || '' : ''),
                Phone: ($("#txtPhone") ? $("#txtPhone").val() || '' : ''),
                CellPhone: ($("#txtCellPhone") ? $("#txtCellPhone").val() || '' : ''),
                StoreId: ($("#ddlCompany") ? $("#ddlCompany").val() || options.storeId : options.storeId),
                StorePositionTypeId: ($("#ddlPosition") ? $("#ddlPosition").val() || '47' : '47'),
                SendEmails: ($("input:radio[name=radReceiveEmail]:checked").val() ? $("input:radio[name=radReceiveEmail]:checked").val() || '0' : '0'),
                ReceiveSMS: ($("input:radio[name=radReceiveText]:checked").val() ? $("input:radio[name=radReceiveText]:checked").val() || '0' : '0'),
                ShareInfo: ($("input:radio[name=radShareInfo]:checked").val() ? $("input:radio[name=radShareInfo]:checked").val() || '0' : '0'),
                DisplayInfo: ($("input:radio[name=radDisplayName]:checked").val() ? $("input:radio[name=radDisplayName]:checked").val() || '0' : '0'),
                OptInSurvey: ($("input:radio[name=radSurveys]:checked").val() ? $("input:radio[name=radSurveys]:checked").val() || '0' : '0'),
                OptinFocusGroup: ($("input:radio[name=radFocus]:checked").val() ? $("input:radio[name=radFocus]:checked").val() || '0' : '0'),
                ShirtSize: ($("#ddlShirtSize") ? $("#ddlShirtSize").val() || '' : ''),
                UID: IREP.options.user.currentUID
            }
        });
        $.ajax({
            type: "POST",
            url: options.apiPath + "participant/forced/update",
            contentType: "application/json; charset=utf-8",
            headers: { "PaxUID": IREP.options.user.currentUID },
            data: myData,
            dataType: "json",
            success: function (msg) {
                if (msg.success) {
                    window.location.href = options.saveURL;
                }
            },
            error: function (msg) { }
        });
    };

    return {
        init: init
    };
})();